/**
 * co-cart-rec.js
 * Custom element for AJAX add-to-cart from cart drawer recommendations.
 * Dispatches 'cart:update' after a successful add so cart-items-component
 * and cart-drawer-component both update in place without a page reload.
 */
class CoCartRecAdd extends HTMLElement {
  connectedCallback() {
    this.querySelector('form')?.addEventListener('submit', this.#handleSubmit);
  }

  disconnectedCallback() {
    this.querySelector('form')?.removeEventListener('submit', this.#handleSubmit);
  }

  #handleSubmit = async (e) => {
    e.preventDefault();
    const form = /** @type {HTMLFormElement} */ (e.target);
    const btn = /** @type {HTMLButtonElement | null} */ (form.querySelector('button[type="submit"]'));

    if (btn) btn.disabled = true;

    /* Collect section IDs to re-render — all cart-items-component instances */
    const cartComponents = /** @type {NodeListOf<HTMLElement>} */ (
      document.querySelectorAll('cart-items-component[data-section-id]')
    );
    const sections = [...cartComponents]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean)
      .join(',');

    const body = new FormData(form);
    if (sections) {
      body.set('sections', sections);
      body.set('sections_url', window.location.pathname);
    }

    try {
      const resp = await fetch('/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body,
      });

      if (!resp.ok) throw new Error(`Cart add failed: ${resp.status}`);

      const data = await resp.json();

      /* Dispatch 'cart:update' — the same event name Horizon uses internally.
         cart-items-component morphs the DOM from data.sections;
         cart-drawer-component calls showDialog() to keep the drawer open. */
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            data: { sections: data.sections ?? {} },
          },
        })
      );
    } catch (err) {
      console.error('[co-cart-rec] add-to-cart error:', err);
    } finally {
      if (btn) btn.disabled = false;
    }
  };
}

if (!customElements.get('co-cart-rec-add')) {
  customElements.define('co-cart-rec-add', CoCartRecAdd);
}
